import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../common/Sidebar";
import Logout from "../../common/Logout";
import LoadingBar from "react-top-loading-bar";
import "../../customCss/Stats.css";
import SalesChart from "../../common/SalesChart";
import SalesRoundChart from "../../common/SalesRoundChart";
import { useNavigate } from "react-router-dom";
import DataService from "../../services/data.service";
import { toast } from "react-toastify";

const labels = ["Tasks Completed", "House Owners", "Contractors"];

const Statistics = () => {
  const navigate = useNavigate();
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const [statsData, setStatsData] = useState([]);
  const [earnData, setEarnData] = useState({})
  const [chartSeries, setChartSeries] = useState([
    { name: "This Year", data: Array(12).fill(0) },
    { name: "Last Year", data: Array(12).fill(0) },
  ]);
  const [roundChartSeries, setRoundChartSeries] = useState([63, 22, 15]);
  const getStatistics = async () => {
    setLoading(true);
    ref.current.continuousStart();
    try {
      const [resp, earnResp] = await Promise.all([
        DataService.getAdminStatistics(),
        DataService.getAdminEarnings(),
      ]);

      const sData = resp?.data?.data;
      const eData = earnResp?.data?.data;
      setStatsData(sData);
      setEarnData(eData)
      setChartSeries([
        {
          name: "This Year",
          data:
            sData?.completedJobsComparison?.currentYear || Array(12).fill(0),
        },
        {
          name: "Last Year",
          data: sData?.completedJobsComparison?.lastYear || Array(12).fill(0),
        },
      ]);
      setRoundChartSeries([
        sData?.totalCompletedJobs || 0,
        sData?.totalUsers || 0,
        sData?.totalContractors || 0,
      ]);
    } catch (error) {
      const resMessage =
        error?.response?.data?.message || "Something went wrong";
      toast.error(resMessage);
    } finally {
      ref.current.complete();
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Snow Bank Additional Form Fields";
    window.scrollTo(0, 0);
    getStatistics();
  }, []);
  return (
    <div className="main_section">
      <div className="main_flex">
        <div className="main_flexL">
          <Sidebar />
        </div>
        <div className="main_flexR">
          <div className="right_title">
            <h1>Statistics</h1>
            <Logout />
          </div>
          {loading && (
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          )}
          <LoadingBar color="#84C342" ref={ref} height={5} />
          <div className="main_innerSec">
            <div className="statSection">
              <div className="statFlex">
                <div
                  className="statBoxInner"
                  style={{ width: "31.50%" }}
                  onClick={() => navigate("/users/house-owners")}
                >
                  <div className="statLeft">
                    <span className="mb-0">Total Earnings</span>
                    <h4>${earnData?.totalEarnings || 0}</h4>
                  </div>
                  <div className="statRight">
                    <i className="fas fa-dollar-sign"></i>
                  </div>
                </div>
                <div
                  className="statBoxInner"
                  style={{ width: "31.50%" }}
                  onClick={() => navigate("/users/contractors")}
                >
                  <div className="statLeft">
                    <span className="mb-0">Earnings from Jobs (Platform Tax)</span>
                    <h4 style={{ color: "#15B79F" }}>
                      ${earnData?.jobEarnings || 0}
                    </h4>
                  </div>
                  <div className="statRight">
                    <i
                      className="fas fa-dollar-sign"
                      style={{ background: "#15B79F" }}
                    ></i>
                  </div>
                </div>
                <div
                  className="statBoxInner"
                  style={{ width: "31.50%" }}
                  onClick={() => navigate("/users/contractors")}
                >
                  <div className="statLeft">
                    <span className="mb-0">Earning from Contractor Fee</span>
                    <h4 style={{ color: "#635BFF" }}>
                      ${earnData?.contractorFee || 0}
                    </h4>
                  </div>
                  <div className="statRight">
                    <i
                      className="fas fa-dollar-sign"
                      style={{ background: "#635BFF" }}
                    ></i>
                  </div>
                </div>
                <div
                  className="statBoxInner"
                  onClick={() => navigate("/users/house-owners")}
                >
                  <div className="statLeft">
                    <span className="mb-0">TOTAL HOUSE OWNERS</span>
                    <h4>{statsData?.totalUsers || "-"}</h4>

                    {statsData?.sinceLastMonthUsersGrowth
                      ?.toString()
                      ?.includes("-") ? (
                      <>
                        <p className="mb-0 down">
                          <i className="fas fa-long-arrow-alt-down"></i>
                          {statsData?.sinceLastMonthUsersGrowth / 100}% Since
                          last month
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="mb-0 up">
                          <i className="fas fa-long-arrow-alt-up"></i>
                          {statsData?.sinceLastMonthUsersGrowth / 100}% Since
                          last month
                        </p>
                      </>
                    )}
                  </div>
                  <div className="statRight">
                    <i className="fas fa-user-tie"></i>
                  </div>
                </div>
                <div
                  className="statBoxInner"
                  onClick={() => navigate("/users/contractors")}
                >
                  <div className="statLeft">
                    <span className="mb-0">TOTAL CONTRACTORS</span>
                    <h4 style={{ color: "#15B79F" }}>
                      {statsData?.totalContractors || "-"}
                    </h4>
                    {statsData?.sinceLastMonthContractorsGrowth
                      ?.toString()
                      ?.includes("-") ? (
                      <>
                        <p className="mb-0 down">
                          <i className="fas fa-long-arrow-alt-down"></i>
                          {statsData?.sinceLastMonthContractorsGrowth / 100}%
                          Since last month
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="mb-0 up">
                          <i className="fas fa-long-arrow-alt-up"></i>
                          {statsData?.sinceLastMonthContractorsGrowth / 100}%
                          Since last month
                        </p>
                      </>
                    )}
                  </div>
                  <div className="statRight">
                    <i
                      className="fas fa-user"
                      style={{ background: "#15B79F" }}
                    ></i>
                  </div>
                </div>
                <div className="statBoxInner">
                  <div className="statLeft">
                    <span className="mb-0">TOTAL TASK COMPLETED</span>
                    <h4 style={{ color: "#635BFF" }}>
                      {statsData?.totalCompletedJobs || "-"}
                    </h4>
                    {statsData?.sinceLastMonthCompletedJobsGrowth
                      ?.toString()
                      ?.includes("-") ? (
                      <>
                        <p className="mb-0 down">
                          <i className="fas fa-long-arrow-alt-down"></i>
                          {statsData?.sinceLastMonthCompletedJobsGrowth / 100}%
                          Since last month
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="mb-0 up">
                          <i className="fas fa-long-arrow-alt-up"></i>
                          {statsData?.sinceLastMonthCompletedJobsGrowth / 100}%
                          Since last month
                        </p>
                      </>
                    )}
                  </div>
                  <div className="statRight">
                    <i
                      className="far fa-check-square"
                      style={{ background: "#635BFF" }}
                    ></i>
                  </div>
                </div>
                <div className="statBoxInner">
                  <div className="statLeft">
                    <span className="mb-0">TOTAL REVIEWS/RATINGS</span>
                    <h4 style={{ color: "#FB9C0C" }}>
                      {statsData?.totalRatings || "-"}
                    </h4>
                  </div>
                  <div className="statRight">
                    <i
                      className="far fa-star"
                      style={{ background: "#FB9C0C" }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="chartFlex row mt-3">
                <div className="col-lg-8 col-md-12 col-12">
                  <SalesChart
                    chartSeries={chartSeries}
                    reloadData={getStatistics}
                    loading={loading}
                  />
                </div>
                <div className="col-lg-4 col-md-12 col-12">
                  <SalesRoundChart
                    chartSeries={roundChartSeries}
                    labels={labels}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
